import { defaultLocale } from '../../translate'
import Cookies from "js-cookie";
import { getCookieDomain } from "../../utils/domain";
const NAME_THEME = 'base-app_theme'
const NAME_LANGUAGE = 'base-app_lang'
const WHITE_THEME = "white-theme"
const DARK_THEME = "dark-theme"
const DEFAULT_THEME = DARK_THEME
const serverRunning = typeof window === 'undefined'

const MARKET_SPOT = 'spot'
const MARKET_CROSS = 'margin'

export {MARKET_SPOT, MARKET_CROSS}

function initTheme() {
    return DARK_THEME
}

function initLang() {
    if(serverRunning) {
        return defaultLocale
    }
    const lang = Cookies.get(NAME_LANGUAGE, { domain: getCookieDomain() })
    return lang === undefined? defaultLocale : lang
}

export {WHITE_THEME, DARK_THEME}
export default {
    actions: {
        changeAppTheme: async ({ commit }, name) => {
            commit('SET_APP_THEME', name)
            if (!serverRunning) {
                Cookies.set(NAME_THEME, name,  { domain:  getCookieDomain() })
            }
        },
        changeAppLanguage: async ({ commit }, name) => {
            commit('SET_APP_LANGUAGE', name)

            if(!serverRunning) {
                Cookies.set(NAME_LANGUAGE, name,  { domain:  getCookieDomain() })
            }

        },
    },
    mutations: {
        SET_APP_THEME(state, name) {
            state.appTheme = name
        },
        SET_APP_LANGUAGE(state, name) {
            state.appLanguage = name
        },
    },
    state: {
        appTheme: initTheme(),
        appLanguage: initLang(),
    },
    getters: {
        getAppTheme:(state) => state.appTheme,
        getAppLanguage:(state) => state.appLanguage,
    }
}